import { LogService as LogServiceAbstraction } from "../abstractions/log.service";
import { LogLevelType } from "../enums/logLevelType";

export class ConsoleLogService implements LogServiceAbstraction {
  protected timersMap: Map<string, [number, number]> = new Map();

  constructor(
    protected isDev: boolean,
    protected filter: (level: LogLevelType) => boolean = null,
  ) {}

  debug(message: string) {
    if (!this.isDev) {
      return;
    }
    this.write(LogLevelType.Debug, message);
  }

  info(message: string) {
    this.write(LogLevelType.Info, message);
  }

  warning(message: string) {
    this.write(LogLevelType.Warning, message);
  }

  error(message: string) {
    this.write(LogLevelType.Error, message);
  }

  table(data: any) {
    if (data?.error) {
      // eslint-disable-next-line
      console.log("ERROR CAUGHT : :::::::::::::::::::::::::::::::::::::::::::");
    }

    if (data?.isRevalAction) {
      // eslint-disable-next-line
      console.log("REVAL::::::::::" + data.action);
      // eslint-disable-next-line no-console
      console.log(`reval info: ${JSON.stringify(data)}`);
      return;
    }

    if (data?.account) {
      // eslint-disable-next-line
      console.log(`${data.account}: ${data.level} :::::::::::::::::::::::::`);
    }

    this.write(LogLevelType.Table, "", data);
  }

  write(level: LogLevelType, message: string, data?: any[]) {
    if (this.filter != null && this.filter(level)) {
      return;
    }

    switch (level) {
      case LogLevelType.Debug:
        // eslint-disable-next-line
        console.log(message);
        break;
      case LogLevelType.Info:
        // eslint-disable-next-line
        console.log(message);
        break;
      case LogLevelType.Warning:
        // eslint-disable-next-line
        console.warn(message);
        break;
      case LogLevelType.Error:
        // eslint-disable-next-line
        console.error(message);
        break;
      case LogLevelType.Custom:
        // eslint-disable-next-line
        console.info(message, ":", data);
        break;
      case LogLevelType.Table:
        // eslint-disable-next-line
        console.dir(data);
        break;
      default:
        break;
    }
  }
}
